import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.998 11.88 9 5.495l1.293 1.214a1 1 0 0 0 .707.294 1 1 0 0 0 .707-1.71L8.706 2.287a1 1 0 0 0-.644-.283A1 1 0 0 0 7.96 2a1 1 0 0 0-.315.061q-.015-.002-.028.007a1 1 0 0 0-.293.2c-.009.01-.02.011-.031.021l-3 3.005a1.004 1.004 0 0 0 .323 1.635 1 1 0 0 0 1.09-.218L6.95 5.496 7 13.008c0 .263.104.515.292.701a1.004 1.004 0 0 0 1.415 0A1 1 0 0 0 9 13.008z" }));
const ForwardRef = forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
